import type { Router, RouteRecordRaw } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { useAuthStore } from '@/stores/modules/auth'
import { usePermissionStore } from '@/stores/modules/permission'

NProgress.configure({ showSpinner: false })

const WHITE_LIST = ['/login', '/404']

function getFirstLeafPath(routes: RouteRecordRaw[]): string {
  for (const r of routes) {
    for (const child of r.children ?? []) {
      if (child.children?.length) {
        for (const leaf of child.children) {
          if (leaf.component) return `/${child.path}/${leaf.path}`
        }
      }
    }
  }
  return '/member/user'
}

export function setupRouterGuards(router: Router) {
  router.beforeEach(async (to, _from, next) => {
    NProgress.start()

    const authStore = useAuthStore()
    const permissionStore = usePermissionStore()
    const token = authStore.token

    if (token) {
      console.log(to, 'to')
      if (to.path === '/login') {
        next({ path: '/' })
      } else if (authStore.userInfo) {
        if (permissionStore.routes.length === 0) {
          const accessRoutes = await permissionStore.generateRoutes()
          accessRoutes.forEach((route) => router.addRoute(route))
          // 注册完异步路由后，"/" 重定向到第一个叶子页面
          if (to.path === '/' || to.redirectedFrom?.path === '/') {
            next({ path: getFirstLeafPath(accessRoutes), replace: true })
          } else {
            next({ path: to.fullPath, replace: true })
          }
        } else if (to.path === '/') {
          next({ path: getFirstLeafPath(permissionStore.routes), replace: true })
        } else {
          next()
        }
      } else {
        // token 存在但 userInfo 丢失（异常状态），清除登录态
        await authStore.logout()
        next(`/login?redirect=${to.path}`)
      }
    } else {
      if (WHITE_LIST.includes(to.path)) {
        next()
      } else {
        next(`/login?redirect=${to.path}`)
      }
    }
  })

  router.afterEach((to) => {
    NProgress.done()
    const title = to.meta?.title as string | undefined
    document.title = title
      ? `${title} | ${import.meta.env.VITE_APP_TITLE}`
      : import.meta.env.VITE_APP_TITLE
  })
}
